import React from 'react';
import { Typography } from 'antd';

import { crawlerCategoryLabel } from '~features/crawler-filter';
import { dates } from '~library/dates';

type FiltersForPrintProps = {
  domainSelected?: string;
  crawlersSelected?: string[];
  /**
   * Already-resolved crawler labels, for callers whose crawler ids aren't
   * dashboard-v3's — AI Insights maps its own granular ids to provider
   * categories. Takes precedence over `crawlersSelected`.
   */
  crawlerLabels?: string[];
  dateFrom: Date;
  dateTo: Date;
};

function FiltersForPrint({
  domainSelected,
  crawlersSelected,
  crawlerLabels,
  dateFrom,
  dateTo,
}: FiltersForPrintProps) {
  const crawlersSelectedLabels = crawlerLabels ?? crawlersSelected?.map(crawlerCategoryLabel);
  const domainLabel = domainSelected || 'All domains';

  return (
    <div>
      <Typography.Paragraph>
        <Typography.Text strong>Domain: </Typography.Text>
        {domainLabel}
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Typography.Text strong>Crawlers: </Typography.Text>
        {crawlersSelectedLabels?.join(', ') || 'All crawlers'}
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Typography.Text strong>Date Range: </Typography.Text>
        {dates.dayOfPointInTime(dateFrom)} - {dates.dayOfPointInTime(dateTo)}
      </Typography.Paragraph>
    </div>
  );
}

export default FiltersForPrint;
